var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:[
    'rtp__status-item',
    {
      '--check': _vm.ruleStatus
    }
  ]},[_c('span',{staticClass:"rtp__item-icon-c"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.ruleStatus),expression:"ruleStatus"}],staticClass:"rtp__item-icon"},[_c('CheckIcon')],1),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.ruleStatus),expression:"!ruleStatus"}],staticClass:"rtp__item-point"},[_vm._v(" • ")])]),_c('span',{staticClass:"rtp__item-text"},[_vm._v(" "+_vm._s(_vm.ruleDescription)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }